import { ICandidate, IJobFieldSettings } from 'wisestep-api';
import { extractDateFromISODate, formattedDateISO } from 'wisestep-base';
import { date, number, object, string } from 'yup';

export interface IStageOption {
  stage: string;
  stageOrder: number;
  statuses: IStatuses[];
  isArchive: boolean;
}

export interface IStatuses {
  value: string;
  status: string;
}

export const updateStageStateFormDefaultValues = (
  candidate: ICandidate | null,
  jobFieldSettings: IJobFieldSettings
) => {
  if (candidate) {
    return {
      applicationStage: candidate?.applicationStage ?? '',
      applicationState: candidate?.applicationState ?? '',
      stageDate: null,
      joiningDate: (candidate.joiningDate && extractDateFromISODate(candidate.joiningDate)) ?? null,
      offeredPayRate: {
        currency:
          candidate?.offeredPayRateCurrency ??
          (jobFieldSettings && jobFieldSettings.defaultCurrency.selectedField
            ? jobFieldSettings.defaultCurrency.selectedField
            : ''),
        value: candidate.offeredPayRate ?? 0,
        timeSpan: candidate.offeredPayRateTimeSpan ?? candidate?.expectedBaseSalaryTimeSpan ?? null,
      },
    };
  }
};

export const updateJobCandidateInteraction = (
  id,
  data,
  editedNote,
  loggedInUserName,
  jobCandidateInteraction,
  otherDocuments
) => {
  jobCandidateInteraction.id = id ?? '';
  jobCandidateInteraction.applicationStage = data.applicationStage;
  jobCandidateInteraction.applicationState = data.applicationState;
  jobCandidateInteraction.stageDate = data.stageDate ?? new Date().toISOString();
  jobCandidateInteraction.joiningDate = data.joiningDate ?? null;
  jobCandidateInteraction.otherDocuments = otherDocuments;
  jobCandidateInteraction.candidateNotes = [
    {
      notes: editedNote,
      createdBy: loggedInUserName ?? '',
      createdAt: formattedDateISO(new Date()),
    },
  ];
  jobCandidateInteraction.stageAndStateActions = [
    {
      stage: data.applicationStage,
      state: data.applicationState,
      id: '',
      updatedBy: loggedInUserName ?? '',
      updatedOn: formattedDateISO(new Date()),
    },
  ];
};

export const stageStatusFormSchema = (mandatoryFields) => {
  return object().shape({
    joiningDate: date().when([], {
      is: () => mandatoryFields.includes('Joining Date'),
      then: date().nullable(false).required('Please provide Joining date'),
      otherwise: date().nullable(true),
    }),
    candidateNotes: string().when([], {
      is: () => mandatoryFields.includes('Comments'),
      then: string().required('Please provide your comments for the stage status'),
    }),
    stageDate: date().when([], {
      is: () =>
        mandatoryFields.includes('Stage Date & Time') || mandatoryFields.includes('Stage Date'),
      then: date().nullable(false).required('Please provide Stage date'),
      otherwise: date().nullable(true),
    }),
    offeredPayRate: object().when([], {
      is: () => mandatoryFields.includes('Offer Payrate'),
      then: object()
        .shape({
          currency: string().required('Currency of candidate is required'),
          value: number()
            .required('Offered Salary/Payrate of candidate is required')
            .min(1, 'Offered Salary/Payrate of candidate is required'),
        })
        .required('Offered Salary/Payrate of candidate is required'),
    }),
  });
};

export const formLabel = (label: string, isRequired: boolean) => label + (isRequired ? '*' : '');
